<div *ngIf="!html; else elseBlock" [class]="props.class ?? 'riquadro'">
  <app-template [name]="template" [data]="data"></app-template>
</div>
<ng-template #elseBlock>
  <div
          [innerHTML]="html"
          [class]="props.class ?? 'riquadro'"
          (click)="props?.back && handleClick($event)">
  </div>
</ng-template>